export const STORAGE_KEY = 'vector_editor_autosave_project';
export const NAME_STORAGE_KEY = 'vector_editor_autosave_project_name';
export const MAX_DIMENSION = 400;
export const MAX_SMALL_GLASS_SIZE = 26;
export const MAX_LARGE_GLASS_SIZE = 46;
export const FULL_SMALL_GLASS_SIZE = '37/26';
export const FULL_LARGE_GLASS_SIZE = '66/46';
export const MM_PER_UNIT = 25.4 / 96;
export const MM_TO_PX = 96 / 25.4;
export const FILL_COLOR = '#d59029';
export const VECTOR_STROKE_COLOR = '#000000';
export const VECTOR_STROKE_WIDTH = '0.1';
export const TRANSFORM_OVERLAY_HANDLE_SIZE_PX = 12;
export const ANGLE_COEFFICIENT = 180;
export const START_ZOOM_PERCENTAGE = 100;
export const START_ZOOM_COEFFICIENT = START_ZOOM_PERCENTAGE / 100;
export const MIN_ZOOM = 0.3;
export const MAX_ZOOM = 3000;
export const MIN_DRAG_DISTANCE = 5;
export const FLATTEN_TOLERANCE_MM = 0.02;

export const UNSUPPORTED_ATTRS = ['text', 'tspan', 'image', 'foreignObject'];

export const SHAPE_TOOLS = [
  'rect', 'square', 'ellipse', 'circle', 'triangle', 'rounded-triangle',
  'hexagon', 'octagon', 'star', 'line', 'arrow', 'rhombus', 'polygon-n',
];

export const IS_PROPORTIONAL = [
  'square', 'circle', 'triangle', 'rounded-triangle', 'hexagon',
  'octagon', 'star', 'rhombus', 'polygon-n',
];

export const RULER_SIZE = 24;
export const SNAP_TOLERANCE_PX = 3;
export const GLASS_PRESETS = {
  '66/46': {outerR: 33, innerR: 23},
  '37/26': {outerR: 18.5, innerR: 13},
};

export const DEFAULT_COLORS = [
  '#EF4444', '#ff8614', '#f5d742', '#07ed0b',
  '#165bca', '#FFFFFF', '#000000'
];

export const BASE_LASER_COLORS = [
  { name: 'black',   hex: '#000000', r: 0,   g: 0,   b: 0   },
  { name: 'white',   hex: '#ffffff', r: 255, g: 255, b: 255 },
  { name: 'red',     hex: '#ff0000', r: 255, g: 0,   b: 0   },
  { name: 'green',   hex: '#00ff00', r: 0,   g: 255, b: 0   },
  { name: 'blue',    hex: '#0000ff', r: 0,   g: 0,   b: 255 },
  { name: 'yellow',  hex: '#ffff00', r: 255, g: 255, b: 0   },
  { name: 'orange',  hex: '#ff8614', r: 255, g: 134, b: 20   },
  { name: 'cyan',    hex: '#00ffff', r: 0,   g: 255, b: 255 },
  { name: 'magenta', hex: '#ff00ff', r: 255, g: 0,   b: 255 }
];

export const LEAF_TAGS = new Set([
  'path', 'polygon', 'polyline', 'rect',
  'circle', 'ellipse', 'line',
]);

export const SKIP_ANCESTOR_TAGS = new Set([
  'clippath', 'mask', 'defs', 'symbol', 'pattern',
]);

export const PRESENTATION_ATTRS = [
  'fill', 'stroke', 'stroke-width',
  'opacity', 'class', 'style'
];




